import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import WaveSurfer from 'wavesurfer.js';

export interface AudioTrack {
  title: string;
  description: string;
  type: 'story' | 'sounds' | 'soul';
  narrator: string;
  durationInMinutes: string;
  languageIntensity: string;
  tags: string[];
  mainTag: string;
  audioUrl: string;
  narratorGender: 'MALE' | 'FEMALE' | 'FEMALE_MALE' | 'MALE_FEMALE' | 'FEMALE_FEMALE' | 'MALE_MALE' | 'DIVERSE';
}

@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  selector: 'app-audio-track',
  templateUrl: './audio-track.component.html',
  styleUrl: './audio-track.component.scss'
})
export class AudioTrackComponent implements AfterViewInit, OnDestroy {
  @ViewChild('waveform') waveformEl: ElementRef;

  @Input() data: AudioTrack;

  @Output() onPlayed = new EventEmitter<AudioTrackComponent>();

  wavesurfer: WaveSurfer;
  isPlaying = false;

  ngAfterViewInit(): void {
    this.wavesurfer = WaveSurfer.create({
      container: this.waveformEl.nativeElement,
      height: 32,
      barWidth: 2,
      barGap: 2,
      barRadius: 2,
      cursorWidth: 0,
      waveColor: '#86695d',
      progressColor: '#FFF2EA',
      cursorColor: 'navy',
      url: this.data.audioUrl,
    });

    this.wavesurfer.on('play', () => { 
      this.isPlaying = true;
      this.onPlayed.emit(this);
    });

    this.wavesurfer.on('pause', () => this.isPlaying = false);
    this.wavesurfer.on('finish', () => this.isPlaying = false);
  }

  ngOnDestroy(): void {
    //TODO: unsubscribe from the events as well
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
    }
  }

  playPause(): void {
    this.wavesurfer.playPause();
  }

  pause(): void {
    this.wavesurfer.pause();
  }
}
